import { useState, useEffect, useRef } from 'react';
import { fetchAutocomplete, type AutocompleteSuggestion } from '../services/ragSearchService';

export function useSearchAutocomplete(lang = 'en') {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState<AutocompleteSuggestion[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const debounceRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (query.length < 2) {
      setSuggestions([]);
      setIsOpen(false);
      return;
    }
    setIsLoading(true);
    debounceRef.current = setTimeout(async () => {
      const results = await fetchAutocomplete(query, lang);
      setSuggestions(results);
      setIsOpen(results.length > 0);
      setIsLoading(false);
    }, 200);
    return () => { if (debounceRef.current) clearTimeout(debounceRef.current); };
  }, [query, lang]);

  return { query, setQuery, suggestions, isLoading, isOpen, setIsOpen };
}
